<!--  -->
<template>
  <div class>
    <!-- <FormItem label="行政区域" prop="host"> -->
    <Cascader
      v-model="selectCommunity"
      :data="community_data"
      placeholder="请选择"
      clearable
      @on-change="communityChange"
      change-on-select
    ></Cascader>
    <!-- </FormItem> -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    cascadePath: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    //这里存放数据
    return {
      selectCommunity: this.cascadePath,
      community_data: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //获取级联行政区域
    getCommunity() {
      if (sessionStorage.getItem("adminRegion")) {
        this.community_data = JSON.parse(sessionStorage.getItem("adminRegion"));
        console.log(this.community_data);
      } else {
        this.$get(this.urlobj.getCommunityCascade, {
          communityId: this.$store.state.communityId,
          nationwide: 1,
          lowestLevelId: 10000007770009
        })
          .then(res => {
            this.community_data = res.rows.length
              ? this.formateData(res.rows)
              : [];
            if (res.rows.length) {
              sessionStorage.setItem(
                "adminRegion",
                JSON.stringify(this.formateData(res.rows))
              );
            }
            console.log("=======community_data=========");
            console.log(this.community_data);
            //this.$emit('communityChange',this.community_data[0].value)
          })
          .catch(e => {
            console.log("=======community error=========");
            console.log(e);
            this.$Message.error("获取行政区域失败");
          });
      }
    },
    //处理行政区域数据
    formateData(data) {
      let returnData = data.map(item => {
        return {
          value: item.communityId,
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : []
        };
      });
      return returnData;
    },
    communityChange(value) {
      this.selectCommunity = value;
      let returndata = value.length
        ? value[value.length - 1]
        : { communityId: "", childrenIdList: [] };
      this.$emit("communityChange", value[value.length - 1]);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getCommunity();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>